import { Sprite, TextStyle } from "pixi.js";
import { UIButtonBase } from "../../../../common/components/UIButtonBase";
import { AdaptiveText } from "ui-pixijs";
import { SettingsResourcesPackage } from "../resources/SettingsResourcesPackage";
import { CommonResourcesPackage } from "../../../../common/resources/CommonResourcesPackage";
import { GameFont } from "../../../../common/GameFont";
import { LocalizationModel } from "../../../../common/models/LocalizationModel";
import { LocalizationKey } from "../../../../localization/Localization";

export class ResetComponent extends Sprite {
    protected closeButton: UIButtonBase;
    protected message: AdaptiveText;
    protected yesButton: UIButtonBase;
    protected noButton: UIButtonBase;

    public get onYesButtonClick() {
        return this.yesButton.onUp;
    }
    public get onNoButtonUp() {
        return this.noButton.onUp;
    }
    public get onCloseButtonUp() {
        return this.closeButton.onUp;
    }
    public constructor(commonResources: CommonResourcesPackage, settingsResources: SettingsResourcesPackage, localization: LocalizationModel) {
        super(settingsResources.assets_popups_settings_frame_small_png);
        this.closeButton = new UIButtonBase({ defaultTexture: commonResources.assets_common_close_button_png });
        this.closeButton.position.set(581, -64);

        this.message = new AdaptiveText(localization.getText(LocalizationKey.ResetMessage), new MessageTextStyle(), 640, 300);

        this.yesButton = new UIButtonBase({ defaultTexture: commonResources.assets_common_button_background_png });
        const yesText = new AdaptiveText(localization.getText(LocalizationKey.Yes), new ButtonsTextStyle(), 140, 140);
        yesText.position.set((this.yesButton.width - yesText.width) * 0.5, (this.yesButton.height - yesText.height) * 0.5 - 13);
        this.yesButton.position.set(100, 450);
        this.yesButton.defaultView.addChild(yesText);

        this.noButton = new UIButtonBase({ defaultTexture: commonResources.assets_common_button_background_png });
        const noText = new AdaptiveText(localization.getText(LocalizationKey.No), new ButtonsTextStyle(), 140, 140);
        noText.position.set((this.noButton.width - noText.width) * 0.5, (this.noButton.height - noText.height) * 0.5 - 13);
        this.noButton.position.set(settingsResources.assets_popups_settings_frame_small_png.width - this.noButton.width - 100, 450);
        this.noButton.defaultView.addChild(noText);

        this.addChild(this.message, this.yesButton, this.noButton, this.closeButton);
        this.message.updateText(false);
        this.message.position.set((settingsResources.assets_popups_settings_frame_small_png.width - this.message.width) * 0.5, 150);
    }
}

class MessageTextStyle extends TextStyle {
    public constructor() {
        super({
            fontSize: 48,
            align: "center",
            fill: "#FFFFFF",
            fontFamily: GameFont.Default
        })
    }
}

class ButtonsTextStyle extends TextStyle {
    public constructor() {
        super({
            fontSize: 40,
            align: "center",
            fill: "#FFFFFF",
            fontFamily: GameFont.Default
        })
    }
}
